import { type Reducer } from "react";
import { type VendorDataChangedAction, vendorDataReducer } from "../../../vendor-data";
import { type GetLensV2Query } from "../../api/query";
import { RangeModifier } from "../../../connections/models";
import { type AddLensGroupInfo } from "../../../groups/components/add-to-lensgroup-modal";
import { LensGroupInfo } from "./LensGroupInfo";
import { GlobalLensDetailsModel } from "./GlobalLensDetailsModel";

export type GlobalLensDetailsActions =
    | {
          type: "changeVendorData";
          groupId: string;
          vendorDataAction: VendorDataChangedAction;
      }
    | { type: "updateGroups"; newGroups: readonly LensGroupInfo[] }
    | { type: "initialize"; lensWithConnections: GetLensV2Query["getLensV2"] }
    | { type: "commitChanges" }
    | { type: "changeSchedule"; groupId: string; scheduleRange: RangeModifier }
    | { type: "addGroups"; groups: AddLensGroupInfo[] }
    | { type: "removeGroup"; groupId: string };

export const globalLensDetailsReducer: Reducer<GlobalLensDetailsModel, GlobalLensDetailsActions> = (state, action) => {
    switch (action.type) {
        case "changeVendorData": {
            return state.updateVendorData(action.groupId, (vendorData) =>
                vendorDataReducer(vendorData, action.vendorDataAction),
            );
        }
        case "updateGroups": {
            return state.updateGroups(action.newGroups);
        }
        case "initialize": {
            return GlobalLensDetailsModel.createFromLensWithConnections(action.lensWithConnections);
        }
        case "commitChanges": {
            return state.commitChanges();
        }
        case "changeSchedule": {
            const { groupId, scheduleRange } = action;
            return state.updateSchedule(groupId, scheduleRange);
        }
        case "addGroups": {
            return state.addGroups(action.groups);
        }
        case "removeGroup": {
            return state.removeGroup(action.groupId);
        }
        default:
            return state;
    }
};
